// extracted by mini-css-extract-plugin
export default {"dropdown":"CurrencySelector_dropdown__FVqKw"};